(function () {
  if (window.__limechatSessionBound) return;
  window.__limechatSessionBound = true;

  var STORAGE_KEY = 'limechat_session';
  var COOKIE_NAME = 'limechat_session';
  var CW_COOKIE = 'cw_conversation';
  var TTL_MS = 12 * 60 * 60 * 1000;
  var pendingWidgetOpen = false;

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, ttlMs) {
    var expires = new Date(Date.now() + ttlMs).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}

    var cookieRaw = readCookie(COOKIE_NAME);
    if (!cookieRaw) return null;

    try {
      return JSON.parse(cookieRaw);
    } catch (e) {
      return null;
    }
  }

  function writeStore(data) {
    var payload = JSON.stringify(data);

    try {
      window.localStorage.setItem(STORAGE_KEY, payload);
    } catch (e) {}

    writeCookie(COOKIE_NAME, payload, TTL_MS);
  }

  function persistSession(sessionId) {
    writeStore({
      sessionId: sessionId || null,
      savedAt: Date.now()
    });

    if (sessionId) writeCookie(CW_COOKIE, sessionId, TTL_MS);
  }

  var stored = readStore();
  if (stored && stored.sessionId && stored.savedAt && Date.now() - stored.savedAt <= TTL_MS) {
    writeCookie(CW_COOKIE, stored.sessionId, TTL_MS);
  } else if (stored && stored.savedAt && Date.now() - stored.savedAt > TTL_MS) {
    persistSession(null);
  }

  function hideWidgetBubble() {
    document.documentElement.classList.add('limechat-hide-bubble');
    window.chatwootSettings = window.chatwootSettings || {};
    window.chatwootSettings.hideMessageBubble = true;

    if (window.$chatwoot && typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
      window.$chatwoot.toggleBubbleVisibility('hide');
    }
  }

  function isWidgetApiReady() {
    return (
      (window.chatwootSDK && typeof window.chatwootSDK.open === 'function') ||
      (window.$chatwoot && typeof window.$chatwoot.toggle === 'function')
    );
  }

  function openWidgetNow() {
    if (window.chatwootSDK && typeof window.chatwootSDK.open === 'function') {
      window.chatwootSDK.open();
      return true;
    }

    if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') {
      window.$chatwoot.toggle('open');
      return true;
    }

    return false;
  }

  function flushPendingWidgetOpen() {
    if (!pendingWidgetOpen) return;
    pendingWidgetOpen = false;
    openWidget();
  }

  function openWidget() {
    if (!isWidgetApiReady()) {
      pendingWidgetOpen = true;
      return;
    }

    window.setTimeout(function () {
      if (!openWidgetNow()) pendingWidgetOpen = true;
    }, 200);
  }

  hideWidgetBubble();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-limechat-open]');
    if (!trigger) return;

    event.preventDefault();
    openWidget();
  });

  function onWidgetReady() {
    hideWidgetBubble();
    flushPendingWidgetOpen();

    var token = readCookie(CW_COOKIE);
    if (token) persistSession(token);

    window.setTimeout(function () {
      var later = readCookie(CW_COOKIE);
      if (later) persistSession(later);
    }, 1500);
  }

  window.addEventListener('chatwoot:ready', onWidgetReady);
  window.addEventListener('lc_widget:ready', onWidgetReady);
})();
